import { chains } from "app/chains";
import { fallback, http } from "viem";
import { customRpc } from "./customRpcMap";

const BSC_HTTP_URLS = [
  customRpc[56],
  "https://bsc.publicnode.com",
  "https://bsc-dataseed.binance.org",
  "https://bsc-mainnet.public.blastapi.io",
].filter(Boolean) as string[];

const ETH_HTTP_URLS = [
  customRpc[1],
  "https://eth.llamarpc.com",
  "https://eth.publicnode.com",
].filter(Boolean) as string[];

const BASE_HTTP_URLS = [
  customRpc[8453],
  "https://base.llamarpc.com",
  "https://base.publicnode.com",
].filter(Boolean) as string[];

const ARBITRUM_HTTP_URLS = [
  customRpc[42161],
  "https://arbitrum.llamarpc.com",
  "https://arbitrum.publicnode.com",
].filter(Boolean) as string[];

const ROBINHOOD_HTTP_URLS = [
  customRpc[4663],
  "https://robinhood-rpc.publicnode.com",
  "https://robinhood.drpc.org",
  "https://robinhood-mainnet.drpc.org",
  "https://4663.rpc.thirdweb.com",
  "https://rpc.mainnet.chain.robinhood.com", // official, rate-limited: last resort
].filter(Boolean) as string[];

type Transport = ReturnType<typeof http> | ReturnType<typeof fallback>;

export const transports: Record<number, Transport> = chains.reduce(
  (map, chain) => {
    if (chain.id === 56) {
      map[56] = fallback(BSC_HTTP_URLS.map((url) => http(url)));
    } else if (chain.id === 1) {
      map[1] = fallback(ETH_HTTP_URLS.map((url) => http(url)));
    } else if (chain.id === 8453) {
      map[8453] = fallback(BASE_HTTP_URLS.map((url) => http(url)));
    } else if (chain.id === 42161) {
      map[42161] = fallback(ARBITRUM_HTTP_URLS.map((url) => http(url)));
    } else if (chain.id === 4663) {
      map[4663] = fallback(ROBINHOOD_HTTP_URLS.map((url) => http(url)));
    } else {
      const url = customRpc[chain.id] ?? chain.rpcUrls.default.http[0];
      map[chain.id] = http(url);
    }
    return map;
  },
  {} as Record<number, Transport>
);
